import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import {
  List,
  Tag,
  Button,
  Modal,
  message,
  Card,
  Space,
  Typography,
} from 'antd';
import { PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import {
  GET_PROJECT_TYPES,
  UPDATE_PROJECT_TYPE,
} from '../../../gql/projectTypes';

const { Text } = Typography;

const ProjectTypes = () => {
  const { data, loading } = useQuery(GET_PROJECT_TYPES, {
    variables: {
      state: 'ALL',
    },
  });
  const [disableLoading, setDisableLoading] = useState('');
  const [updateProjectType] = useMutation(UPDATE_PROJECT_TYPE, {
    refetchQueries: ({
      data: {
        updateProjectType: { id },
      },
    }) => [
      { query: GET_PROJECT_TYPES, variables: { ids: [id], state: 'ALL' } },
      { query: GET_PROJECT_TYPES, variables: { state: 'ACTIVE' } },
    ],
    onCompleted: async () => {
      // await sleep(500);
      setDisableLoading('');
    },
    onError: (err) => {
      console.log(err);
    },
  });
  const [deleteProjectType, { loading: deleteLoading }] = useMutation(
    UPDATE_PROJECT_TYPE,
    {
      refetchQueries: [
        { query: GET_PROJECT_TYPES, variables: { state: 'ALL' } },
        { query: GET_PROJECT_TYPES, variables: { state: 'ACTIVE' } },
      ],
      onCompleted: async () => {
        // await sleep(500);
        setDisableLoading('');
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  const listActions = ({ item }) => {
    return [
      <Link key="edit" to={`/system-setting/project-types/${item.id}`}>
        Edit
      </Link>,
      <Button
        type="link"
        key="state"
        loading={disableLoading === item.id}
        onClick={() => {
          setDisableLoading(item.id);
          updateProjectType({
            variables: {
              input: {
                id: item.id,
                name: item.name,
                description: item.description,
                disabled: !item.disabled,
                deleted: false,
              },
            },
          });
        }}
      >
        {item.disabled ? 'Active' : 'Disable'}
      </Button>,
      <Button
        type="link"
        key={item.id}
        onClick={() => {
          Modal.confirm({
            title: `${item.name}`,
            icon: <ExclamationCircleOutlined />,
            content: 'Confirm to delete this project type?',
            cancelButtonProps: {
              loading: deleteLoading,
            },
            okButtonProps: {
              loading: deleteLoading,
            },
            onOk: async () => {
              try {
                await deleteProjectType({
                  variables: {
                    input: {
                      id: item.id,
                      name: item.name,
                      description: item.description,
                      disabled: true,
                      deleted: true,
                    },
                  },
                });
                message.success(`${item.name} successfully deleted`);
              } catch (error) {
                console.log(error);
              }
            },
          });
        }}
      >
        Delete{' '}
      </Button>,
    ];
  };

  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Project Types',
        extra: [
          <Button key="add" type="primary">
            <Link to="/system-setting/project-types/add">
              <PlusOutlined /> Add
            </Link>
          </Button>,
        ],
      }}
    >
      <Card bordered={false}>
        <List
          itemLayout="horizontal"
          dataSource={data?.projectTypes}
          renderItem={(item) =>
            item.deleted ? (
              ''
            ) : (
              <List.Item
                actions={listActions({ item })}
                style={{ flexWrap: 'wrap' }}
              >
                <List.Item.Meta
                  title={item.name}
                  description={item.description}
                  style={{ minWidth: '260px' }}
                />
                <Space size={40} style={{ minWidth: '160px' }}>
                  <Text type="secondary">Seq: {item.seq}</Text>
                  {item.disabled ? (
                    <Tag>Disabled</Tag>
                  ) : item.deleted ? (
                    <Tag color="red">Deleted</Tag>
                  ) : (
                    <Tag color="green">Active</Tag>
                  )}
                </Space>
              </List.Item>
            )
          }
        ></List>
      </Card>
    </PageContainer>
  );
};

export default ProjectTypes;
